import {Component, inject, Input, OnInit} from '@angular/core';
import {UiToolsService} from '../../core/ui-tools.service';
import {UploadService} from '../../core/media-upload/upload.service';
import {UploadType} from '../../core/media-upload/upload.types';
import {snapshotFiles} from '../../core/media-upload/upload.helpers';
import {MetaField} from "../../core/definitions/meta-field";

@Component({
    selector: 'app-edit-field-image-selector',
    templateUrl: './edit-field-image-selector.component.html',
    styleUrls: ['./edit-field-image-selector.component.scss'],
    standalone: false
})
export class EditFieldImageSelectorComponent implements OnInit {
  // Injections
  private readonly uiTools: UiToolsService = inject(UiToolsService);
  private readonly uploadService: UploadService = inject(UploadService);

  @Input() field: MetaField;
  @Input() object: any;

  computer = true;

  ngOnInit() {
    this.computer = this.uiTools.getClientType().isComputer;
  }

  deleteImage() {
    this.object[this.field.name].value = null;
  }

  // At the drag drop area
  // (drop)="onDropFile($event)"
  onDropFile(event: any) {
    event.preventDefault();
    this.uploadFiles(snapshotFiles(event.dataTransfer?.files));
  }

  // At the drag drop area
  // (dragover)="onDragOverFile($event)"
  onDragOverFile(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  // At the file input element
  // (change)="selectFile($event)"
  onFileSelect(event: any) {
    const input = event.target as HTMLInputElement;
    const files = snapshotFiles(input.files);
    input.value = '';
    this.uploadFiles(files);
  }

  private uploadFiles(files: File[]) {
    if (files.length > 0) {
      this.object[this.field.name].value = null;
      this.uploadService.uploadFiles(files, UploadType.IMAGE, this.object).then(res => {
        if (res && res[0]) {
          this.object[this.field.name].value = res[0].artifact_id;
          this.object[this.field.name].thumbnail_id = res[0].artifact_id;
          this.object[this.field.name].$$uploading = true;
        } else {
          console.warn('Illegal result received from upload: ' + res);
        }
      });
    }
  }
}
